function formatCompactPriceRaw(value) {
  const num = parseFloat(value);
  if (isNaN(num) || num <= 0) return null;

  if (num >= 1000000) {
    return {
      value: (num / 1000000).toFixed(num % 1000000 >= 100000 ? 1 : 0),
      suffix: "mi",
    };
  } else if (num >= 1000) {
    return {
      value: (num / 1000).toFixed(num % 1000 >= 100 ? 1 : 0),
      suffix: "mil",
    };
  }

  return {
    value: num.toLocaleString("pt-BR"),
    suffix: "",
  };
}

export default function formatPriceMinMax({ min, max }) {
  const minNumber = parseFloat(min);
  const maxNumber = parseFloat(max);

  if (!minNumber && !maxNumber) return null;

  const minFormatted = formatCompactPriceRaw(minNumber);
  const maxFormatted = formatCompactPriceRaw(maxNumber);

  if (minNumber > 0 && maxNumber > 0) {
    if (minFormatted.suffix === maxFormatted.suffix)
      return `R$ ${minFormatted.value}-${maxFormatted.value} ${maxFormatted.suffix}`.trim();

    return `R$ ${minFormatted.value} ${minFormatted.suffix}-${maxFormatted.value} ${maxFormatted.suffix}`.trim();
  }

  if (minNumber > 0)
    return `≥ R$ ${minFormatted.value} ${minFormatted.suffix}`.trim();

  return `≤ R$ ${maxFormatted.value} ${maxFormatted.suffix}`.trim();
}
